import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_avatar, {
      size: "86px",
      color: "grey-3",
      "text-color": "grey-6"
    }, {
      default: _withCtx(() => [
        (_ctx.face && _ctx.face.imageUrl)
          ? (_openBlock(), _createBlock(_component_q_img, {
              key: 0,
              src: _ctx.face.imageUrl,
              ratio: 1,
              fit: "cover"
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_q_icon, {
              key: 1,
              name: "fa fa-user-circle",
              size: "86px"
            })),
        _createVNode(_component_q_tooltip, { delay: 300 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.label), 1),
            (_ctx.personFaceCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.personFaceCount) + " " + _toDisplayString(_ctx.personFaceCount === 1 ? 'face' : 'faces'), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}